import { render, staticRenderFns } from "./MeetingCard.vue?vue&type=template&id=06d5abf8&scoped=true"
import script from "./MeetingCard.vue?vue&type=script&lang=js"
export * from "./MeetingCard.vue?vue&type=script&lang=js"
import style0 from "./MeetingCard.vue?vue&type=style&index=0&id=06d5abf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d5abf8",
  null
  
)

export default component.exports